import script from "./ButtonMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonMain.vue?vue&type=script&setup=true&lang=js"

import "./ButtonMain.vue?vue&type=style&index=0&id=d42e060e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42e060e"]])

export default __exports__